import { ref } from 'vue';

const STORAGE_KEY = 'mesh-theme';
const THEME_DARK = 'dark';
const THEME_LIGHT = 'light';

const currentTheme = ref(THEME_LIGHT);

const applyTheme = (theme) => {
  const normalizedTheme = theme === THEME_DARK ? THEME_DARK : THEME_LIGHT;
  const rootElement = document.documentElement;

  rootElement.classList.toggle(THEME_DARK, normalizedTheme === THEME_DARK);
  currentTheme.value = normalizedTheme;
  localStorage.setItem(STORAGE_KEY, normalizedTheme);
};

const getInitialTheme = () => {
  const savedTheme = localStorage.getItem(STORAGE_KEY);
  if (savedTheme === THEME_DARK || savedTheme === THEME_LIGHT) {
    return savedTheme;
  }

  return window.matchMedia('(prefers-color-scheme: dark)').matches ? THEME_DARK : THEME_LIGHT;
};

const initTheme = () => {
  applyTheme(getInitialTheme());
  return currentTheme.value;
};

const toggleTheme = () => {
  applyTheme(currentTheme.value === THEME_DARK ? THEME_LIGHT : THEME_DARK);
};

export function useThemeMode() {
  return {
    currentTheme,
    initTheme,
    applyTheme,
    toggleTheme,
  };
}
